import styled from 'styled-components'
import { RowCenter } from '../Row'

import IconTriangle from '../../assets/svg/triangle_down.svg'

export const Loading = styled(RowCenter)<{ align?: string }>`
  align-items: ${({ align }) => (align ? align : 'flex-start')};
  height: 64px;
`

export const Dots = styled.span`
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
`

interface TriangleProps {
  active?: boolean
  margin?: string
}
const IconTriangleWrapper = styled.div<TriangleProps>`
  display: flex;
  width: 8px;
  height: 5px;
  margin: ${({ margin }) => (margin ? margin : 'initial')};
  transition: transform 0.3s;
  transform-origin: 50% 50%;
  transform: ${({ active }) => (active ? 'rotate(180deg)' : 'initial')};
`
export const StyledIconTriangle = ({ active, margin }: TriangleProps) => {
  return (
    <IconTriangleWrapper active={active} margin={margin}>
      <IconTriangle />
    </IconTriangleWrapper>
  )
}

interface MoreButton {
  background?: string
  borderRadius?: number
  borderColor?: string
  color?: string
  width?: number
  height?: number
  margin?: string
}
export const MoreButton = styled.a<MoreButton>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme, background }) => (background ? background : theme.white)};
  border: 1px solid ${({ theme, borderColor }) => (borderColor ? borderColor : theme.bsBorder2)};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : 24)}px;
  color: ${({ theme, color }) => (color ? color : theme.text5)};
  width: ${({ width }) => (width ? width : 240)}px;
  height: ${({ height }) => (height ? height : 48)}px;
  margin: ${({ margin }) => (margin ? margin : '0px 0px')};
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.white};
    border: none;
    box-shadow: 0px 0px 17.4194px rgba(0, 0, 0, 0.15);
  }
`
